export default [
  {
    title: "Tum Nguyen",
    description:
      "First and foremost an engineer, Thong (Tum) has been obsessed with computers since he was a kid, writing games on his C64. Thong graduated with a Computer Science degree from the University of Canterbury and has been shipping software and building teams ever since. C#, C++ and Swift are his favourite programming languages.",
    role: "Founder, Engineer",
    linkedin_url: "https://www.linkedin.com/in/tumtumtum",
    photo_url: "./images/team/thong-nguyen@2x.png"
  },
  {
    title: "Alexandra Nguyen",
    description:
      "Alex graduated from the University of Canterbury in 2004 with an Honours degree in Operations Research. Nothing is more satisfying to her than bringing skilled people together to create an environment that nurtures collaboration, leveraging the often-untapped talent within a company. In her spare time, you’ll find her on her yoga mat.",
    role: "Founder, Project Director",
    linkedin_url: "https://www.linkedin.com/in/alexsuggate",
    photo_url: "./images/team/alexandra-nguyen@2x.png"
  },
  {
    title: "Nick Pelling",
    description:
      "Nick is a talented and accomplished digital product designer with over 10 years’ experience helping early stage start-ups and industry leading brands turn complex problems into meaningful user centric solutions.",
    role: "Designer",
    linkedin_url:
      "https://www.linkedin.com/in/nick-pelling-60a002286/?originalSubdomain=uk",
    photo_url: "./images/team/nick-pelling@2x.png"
  },
  {
    title: "Sandra Schnellhaus",
    description:
      "A creative eye with a passion for visual communication, Sandra  produces engaging, high-quality photos and videos, digital design and animation, and seamless storytelling for varied digital and social platforms. Sandy lends a strategic perspective when it comes to content creation, brand, messaging, and using social media platforms.",
    role: "Designer",
    linkedin_url: "https://www.linkedin.com/in/sandra-schnellhaus/",
    photo_url: "/images/team/sandra@2x.png"
  },
  {
    title: "Ya-Sheng Cheng",
    description:
      "Ya-Sheng is all about making online experiences awesome. She doesn't just solve problems – she adds a touch of delight. From coming up with ideas, sketching designs, and creating visuals, she enjoys the whole creative process. She's a team player who inspires everyone on the team to bring out their most creative and considered thinking.",
    role: "Designer",
    inkedin_url: "https://www.linkedin.com/in/yashengcheng/",
    photo_url: "./images/team/ya-sheng.png"
  },
  {
    title: "Sam Cook",
    description:
      "Sam has over 20 years of commercial experience in software development & operations, from building music & video streaming platforms, websites and APIs, to managing servers, networks & cloud platforms.",
    role: "Engineer",
    linkedin_url: "https://www.linkedin.com/in/samcook",
    photo_url: "./images/team/sam-cook@2x.png"
  },
  {
    title: "Tamas Szigyarto",
    description:
      "Tamas graduated from St. Petersburg State University with a masters degree in Applied Mathematics & Programming. He has over 2 decades of experience as a backend software engineer working in various companies across the financial & public sectors. He’s interested in building scalable, high performance systems.",
    role: "Engineer",
    linkedin_url: "https://www.linkedin.com/in/tszigyarto",
    photo_url: "./images/team/tamas-szigyarto@2x.png"
  },
  {
    title: "Mark Kneale",
    description:
      "Mark started his career over 20 years ago as an IT consultant specialising in VMware & Citrix virtualisation. He moved on to study software engineering  and has a wealth of experience developing both mobile & web applications for early stage startups, insurance and fin-tech clients.",
    role: "Engineer",
    linkedin_url: "https://www.linkedin.com/in/markkneale",
    photo_url: "./images/team/mark-kneale@2x.png"
  },
  {
    title: "Rob Gilbert",
    description:
      "Rob specialises in architecting & building modern frontend applications. He approaches his work meticulously to deliver original & efficient software solutions. Rob has a keen interest in good UX, high performance & accessibility.",
    role: "Engineer",
    linkedin_url: "https://www.linkedin.com/in/rob-gilbert-1b6679168",
    photo_url: "./images/team/rob-gilbert@2x.png"
  },
  {
    title: "Anton Sizikov",
    description:
      "A software engineer with experience in various fields and technologies: mobile, desktop, and web. Paying your technical debt since 2010.",
    role: "Engineer",
    linkedin_url: "https://www.linkedin.com/in/sizikov/",
    photo_url: "./images/team/anton-sizikov@2x.png"
  },
  {
    title: "Dmitry Tashkinov",
    description:
      "Dmitry has been working as a software engineer since he graduated in 2003 with a degree in Applied Mathematics and Programming. His technical expertise spans backend and frontend development, having worked with .NET, Java, JavaScript, React and Python across desktop, web and mobile platforms. Dmitry is driven by his passion for innovative technology and cutting-edge products.",
    role: "Engineer",
    linkedin_url: "https://www.linkedin.com/in/dmitry-tashkinov-24b10818",
    photo_url: "./images/team/dmitry-tashkinov@2x.png"
  }
];
